export default {
    dataTable: {
        rowsPerPageText: 'Lignes par sous-page:'
    }
};